export class KsManager {
    createName = '';
    createTime?: Date;
    groupId?: number;
    id?: number;
    managerId = '';
    managerName = '';
    type?: number;
    updateName = '';
    updateTime?: Date;
    isSelect = false;
}
